import 'css-chunksrc/client/scenes/projectPortfolioEdition/styles.scss';export default {
  "projectPortfolioEdition": "_projectPortfolioEdition_1tia6_1",
  "main": "_main_1tia6_5",
  "form": "_form_1tia6_18",
  "buttons": "_buttons_1tia6_24"
};